import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Typography,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  IconButton,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { PAGESEND } from "../api/endpoint";
import { handleInternalAsset, handleExternalAsset, getUniqueExtAssetName, getUniqueIntAssetName } from "../api/Services/assetServices";
import { CustomMessage } from "../const/Spinner";
import { setLoading } from "../store/CommonSlice";
import { createTimeSheet } from "../api/Services/masterServie";
import { useNavigate } from "react-router-dom";


// Row type
type RigRow = {
  type: string;
  familyAssetId: string;
  familyName?: string;
  assetName: string;
  owner: string;
  groupCode: string;
  harmony: string;
  description: string;
  assetOptions?: AssetOption[];
  timesheet?: Record<string, string>;
  
}

interface AssetOption {
  assetName: string;
  ownerName: string;
  groupCode: string | null;
  harmonyCode: string | null;
  harmonyName: string | null;
}


// Rig type
type Rig = {
  name: string;
  rows: RigRow[];
};

interface AddRigDialogProps {
  open: boolean;
  onClose: () => void;
  fromdate: string;
  todate: string;
  payload: any;
  onResetParent?: () => void;
  editData?: any; month?: string; year?: string;
  setOpen?: (open: boolean) => void;
  getListOfSelectedProducts?: () => void; // ✅ Add this line
}


const AddRigDialog: React.FC<AddRigDialogProps> = ({ 
    open,
  onClose,
  fromdate,
  todate, month,year,
  payload,
  onResetParent,
  editData,
  setOpen, // ✅ Add this
  getListOfSelectedProducts,
 }) => {
  const [rigs, setRigs] = useState<Rig[]>([]);
  const [newRigName, setNewRigName] = useState("");
  console.log("Date:", editData);
  const navigate = useNavigate();

  // track open timesheet per rig/row
  const [openTimesheet, setOpenTimesheet] = useState<{ rigIndex: number; rowIndex: number } | null>(null);
    useEffect(() => {
  if (editData && editData.length > 0) {
    // Normalize backend rigs (convert rigName → name)
    const formatted = editData.map((rig: any) => ({
      name: rig.rigName || rig.name || "",
      rows: rig.rows.map((row: any) => ({
        type: row.type || "",
        familyAssetId: row.familyAssetId || "",
        assetName: row.assetName || "",
        owner: row.owner || "",
        groupCode: row.groupCode || "",
        harmony: row.harmony || "",
        description: row.description || "",
        timesheet: row.timesheet || {},
      })),
    }));

    setRigs(formatted); 
    console.log("dat", rigs)
        }
}, [editData]);
  

  const [internalfamilies, setinternalfamilies] = useState<
    { label: string; value: string | "" }[]
    >([]);

    const [intAssets, setIntAssets] = useState<
    { label: string; value: string | null }[]
    >([]);

    const [extAssets, setExtAssets] = useState<
    { label: string; value: string | null }[]
    >([]);

    useEffect(() => {
      if (internalfamilies.length === 0) getInternalAssetTypeList(1, PAGESEND);
    }, [internalfamilies]);

    const getInternalAssetTypeList = async (page: number, rows: number) => {
   
    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleInternalAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | "" }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: "" });

       
        console.log("Updated asset type list:", updatedData);

        setinternalfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
    
      console.log("Asset type fetch completed.");
    }
    };

    const [externalfamilies, setexternalfamilies] = useState<
    { label: string; value: string | ""}[]
    >([]);

    useEffect(() => {
      if (externalfamilies.length === 0) getExternalAssetTypeList(1, PAGESEND);
    }, [externalfamilies]);

    const getExternalAssetTypeList = async (page: number, rows: number) => {
 
    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleExternalAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | ""}[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: "" });

       
        console.log("Updated asset type list:", updatedData);

        setexternalfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
    
      console.log("Asset type fetch completed.");
    }
    };

    useEffect(() => {
      if (editData && editData.length > 0) {
        const formatted = editData.map((rig: any) => ({
          name: rig.rigName || rig.name || "",
          rows: rig.rows.map((row: any) => ({
            type: row.type || "",
            familyAssetId: row.familyAssetId || "",
            assetName: row.assetName || "",
            owner: row.owner || "",
            groupCode: row.groupCode || "",
            harmony: row.harmony || "",
            description: row.description || "",
            timesheet: row.timesheet || {},
            assetOptions: [],
          })),
        }));

        setRigs(formatted);

        // 🔄 Prefill family + asset options for edit mode
        formatted.forEach(async (rig: any, rigIndex: number) => {
      for (let rowIndex = 0; rowIndex < rig.rows.length; rowIndex++) {
        const row = rig.rows[rowIndex];

        // Only fetch assets if we have a type
        if (row.type) {
          let assets: any[] = [];
          if (row.type === "internal") {
            assets = await getIntAssetNameList(Number(row.familyAssetId || 0));
          } else {
            assets = await getExtAssetNameList(Number(row.familyAssetId || 0));
          }

          // Update that specific row’s asset options
          setRigs((prev) => {
            const newRigs = [...prev];
            if (newRigs[rigIndex]?.rows[rowIndex]) {
              newRigs[rigIndex].rows[rowIndex].assetOptions = assets;
            }
            return newRigs;
          });
        }
      }
    });

      }
    }, [editData]);

    useEffect(() => {
      if (editData && editData.length > 0) {
        setOpenTimesheet({ rigIndex: 0, rowIndex: 0 });
      }
    }, [editData]);



  if (!open) return null;

  const createEmptyRow = (): RigRow => ({
    type: "",
    familyAssetId: "",
    assetName: "",
    owner: "",
    groupCode: "",
    harmony: "",
    description: "",
  });





  const handleAddRig = () => {
    if (newRigName.trim()) {
      setRigs([...rigs, { name: newRigName, rows: [createEmptyRow()] }]);
      setNewRigName("");
    }
  };

  const handleDeleteRig = (rigIndex: number) => {
  setRigs((prevRigs) => prevRigs.filter((_, index) => index !== rigIndex));
};


  const handleAddRow = (rigIndex: number) => {
    const updatedRigs = [...rigs];
    updatedRigs[rigIndex].rows.push(createEmptyRow());
    setRigs(updatedRigs);
  };

const handleRowChange = <K extends keyof RigRow>(
  rigIndex: number,
  rowIndex: number,
  field: K,
  value: RigRow[K]
) => {
  setRigs((prevRigs) => {
    const updatedRigs = prevRigs.map((rig, rIdx) =>
      rIdx === rigIndex
        ? {
            ...rig,
            rows: rig.rows.map((row, rowIdx) =>
              rowIdx === rowIndex
                ? field === "timesheet"
                  ? {
                      ...row,
                      timesheet: {
                        ...(row.timesheet ?? {}),
                        ...(value as Record<string, string>),
                      },
                    }
                  : { ...row, [field]: value }
                : row
            ),
          }
        : rig
    );

    console.log("Updated rigs state:", updatedRigs);
    return updatedRigs;
  });
};




  const handleDeleteRow = (rigIndex: number, rowIndex: number) => {
    const updatedRigs = [...rigs];
    if (updatedRigs[rigIndex].rows.length > 1) {
      updatedRigs[rigIndex].rows.splice(rowIndex, 1);
      setRigs(updatedRigs);
    }
  };



const generateDateRange = (start: string, end: string): string[] => {
  const dates: string[] = [];
  if (!start || !end) return dates;

  let current = dayjs(start);
  const last = dayjs(end);

  while (current.isBefore(last) || current.isSame(last)) {
    dates.push(current.format("YYYY-MM-DD"));
    current = current.add(1, "day");
  }

  return dates;
};

const copyTimesheet = (rigIndex: number, sourceRowIndex: number, targetRowIndex: number) => {
  setRigs((prevRigs) => {
    const newRigs = [...prevRigs];
    const sourceTimesheet = { ...newRigs[rigIndex].rows[sourceRowIndex].timesheet };
    newRigs[rigIndex].rows[targetRowIndex].timesheet = { ...sourceTimesheet };
    return newRigs;
  });
};


const getExtAssetNameList = async (
  familyAssetId: number
): Promise<
  {
    assetName: string;
    ownerName: string;
    groupCode: string | null;
    harmonyCode: string | null;
    harmonyName: string | null;
  }[]
> => {
  try {
    const { data, status } = await getUniqueExtAssetName(familyAssetId);

    if (status.code === 200 && Array.isArray(data)) {
      return data.map(a => ({
        assetName: a.assetName || "",
        ownerName: a.ownerName || "",
        groupCode: a.groupCode || "",
        harmonyCode: a.harmonyCode || "",
        harmonyName: a.harmonyName || "",
      }));
    }
  } catch (error: any) {
    console.error("Error fetching external assets:", error);
    CustomMessage(error?.message, "error", enqueueSnackbar);
  }

  return [];
};

const getIntAssetNameList = async (
  familyAssetId: number
): Promise<
  {
    assetName: string;
    ownerName: string;
    groupCode: string | null;
    harmonyCode: string | null;
    harmonyName: string | null;
  }[]
> => {
  try {
    const { data, status } = await getUniqueIntAssetName(familyAssetId);

    if (status.code === 200 && Array.isArray(data)) {
      return data.map(a => ({
        assetName: a.assetName || "",
        ownerName: a.ownerName || "",
        groupCode: a.groupCode || "",
        harmonyCode: a.harmonyCode || "",
        harmonyName: a.harmonyName || "",
      }));
    }
  } catch (error: any) {
    console.error("Error fetching internal assets:", error);
    CustomMessage(error?.message, "error", enqueueSnackbar);
  }

  return [];
};


const handleSubmitAllRigs = async () => {
  if (!payload?.fromdate || !payload?.todate) {
    CustomMessage("Please select both From and To dates.", "error", enqueueSnackbar);
    return;
  }

  const finalPayload = {
    ...payload,
    rigs: rigs.map((rig) => ({
      rigName: rig.name,
      rows: rig.rows.map((row) => ({
        type: row.type,
        familyAssetId: row.familyAssetId,
        assetName: row.assetName,
        owner: row.owner,
        groupCode: row.groupCode,
        harmony: row.harmony,
        description: row.description,
        timesheet: row.timesheet || {},
      })),
    })),
  };

  console.log("✅ Final Payload to Send:", finalPayload);

  try {
    const response = await createTimeSheet(finalPayload);
    CustomMessage("Timesheet saved successfully!", "success", enqueueSnackbar);

    setRigs([]);

    if (onResetParent) onResetParent();

    // ✅ Close the CreateTimeSheet dialog
    if (setOpen) setOpen(false);

    // ✅ Refresh the Timesheet table after close
    if (getListOfSelectedProducts) getListOfSelectedProducts();
    // navigate("/erp/pages/timeSheets/view-timesheets");

  } catch (error: any) {
    CustomMessage(error?.message || "Something went wrong", "error", enqueueSnackbar);
  }
};

const handleCancel = () => {

  setRigs([]);

  if (onResetParent) onResetParent(); 
  if (setOpen) setOpen(false);
  if (getListOfSelectedProducts) getListOfSelectedProducts(); 

};






 


return (
  <div
    style={{
      marginTop: 15,
      padding: 10,
      border: "1px solid #ccc",
      borderRadius: 6,
      background: "#f9f9f9",
    }}
  >
    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
      Add Rig
    </Typography>

    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
      <TextField
        label=""
        value={newRigName}
        onChange={(e) => setNewRigName(e.target.value)}
        size="small"
        variant="outlined"
        sx={{ width: 220 }}
      />
      <Button
        variant="contained"
        size="small"
        sx={{ backgroundColor: "#d32f2f", "&:hover": { backgroundColor: "#b71c1c" } }}
        onClick={handleAddRig}
      >
        SAVE
      </Button>
    </Box>

    {rigs.map((rig, rigIndex) => (
      
      <Card key={rigIndex} style={{ marginTop: 16, padding: 16 }}>
        
        {/* Rig Header Line */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{rig.name}</Typography>
          <Box display="flex" gap={1}>
            <Button
              variant="outlined"
              size="small"
              color="error"
              onClick={() => handleDeleteRig(rigIndex)}
            >
              Delete Rig
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleAddRow(rigIndex)}
            >
              + Add Row
            </Button>
          </Box>
        </Box>



        <Box sx={{ overflowX: "auto", mt: 1 }}>
            <Table size="small" style={{ minWidth: 1200 }}>
          <TableHead>
            <TableRow>
              <TableCell>Internal / External</TableCell>
              <TableCell>Family</TableCell>
              <TableCell>Asset Name</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell>Group Code</TableCell>
              <TableCell>Harmony</TableCell>
              <TableCell>Asset Description</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell></TableCell>
              {/* Extra headers for dates */}
              {openTimesheet?.rigIndex === rigIndex &&
              fromdate &&
              todate &&
              generateDateRange(fromdate, todate).map((date, dateIndex) => (
                <TableCell
                  key={dateIndex}
                 sx={{
                minWidth: 30,
                maxWidth: 50,
                width: 30,
             px: 3.5,
            py: 0,

                verticalAlign: "middle",
              }}
                            >
                  <Box
                    sx={{
                      writingMode: "vertical-rl",
                      transform: "rotate(180deg)",
                      textAlign: "center",
                      fontSize: 12,
                      whiteSpace: "nowrap",
                    }}
                  >
                  {date}
                  </Box>
                </TableCell>
              ))}

            </TableRow>
          </TableHead>

          <TableBody>
    
          {rig.rows.map((row, rowIndex) => (
            
            <TableRow key={rowIndex}>   
                     

          <TableCell sx={{ width: 200, maxWidth: 200, minWidth: 200 }}>
            <TextField
              select
              size="small"
              value={row.type}
              onChange={(e) =>
                handleRowChange(rigIndex, rowIndex, "type", e.target.value)
              }
              fullWidth // <-- add this
            >
              <MenuItem value="internal">Internal</MenuItem>
              <MenuItem value="external">External</MenuItem>
            </TextField>
          </TableCell>

          <TableCell sx={{ width: 200, maxWidth: 200, minWidth: 200 }}>
          <Autocomplete
            size="small"
            freeSolo
            options={row.type === "internal" ? internalfamilies : externalfamilies}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.label
            }
            value={
              (row.type === "internal" ? internalfamilies : externalfamilies)
                .find((opt) => opt.value === String(row.familyAssetId)) ||
              null
            }
            onChange={async (e, newValue) => {
              const selectedFamilyId =
                typeof newValue === "string" ? newValue : newValue?.value || "";

              handleRowChange(rigIndex, rowIndex, "familyAssetId", selectedFamilyId);

              if (selectedFamilyId) {
                let assets: any[] = [];
                if (row.type === "internal") {
                  assets = await getIntAssetNameList(Number(selectedFamilyId));
                } else {
                  assets = await getExtAssetNameList(Number(selectedFamilyId));
                }

                console.log("Mapped assets:", assets);
                handleRowChange(rigIndex, rowIndex, "assetOptions", assets);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select or type family" size="small" />
            )}
          />
        </TableCell>



          {/* <TableCell sx={{ width: 200, maxWidth: 200, minWidth: 200 }}>
            <Autocomplete
              size="small"
              freeSolo
              options={row.type === "internal" ? internalfamilies : externalfamilies}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              value={
                row.familyAssetId
                  ? (row.type === "internal"
                      ? internalfamilies
                      : externalfamilies
                    ).find((opt) => opt.value === row.familyAssetId) || row.familyAssetId
                  : null
              }
              onChange={async (e, newValue) => {
                const selectedFamilyId =
                  typeof newValue === "string" ? newValue : newValue?.value || "";

                handleRowChange(rigIndex, rowIndex, "familyAssetId", selectedFamilyId);

                if (selectedFamilyId) {
                  let assets: any[] = [];
                  if (row.type === "internal") {
                    assets = await getIntAssetNameList(Number(selectedFamilyId));
                  } else {
                    assets = await getExtAssetNameList(Number(selectedFamilyId));
                  }

                  console.log("Mapped assets:", assets);
                  handleRowChange(rigIndex, rowIndex, "assetOptions", assets);
                }
              }}

              renderInput={(params) => (
                <TextField {...params} placeholder="Select or type family" size="small" />
              )}
            />
          </TableCell> */}

          <TableCell sx={{ width: 220, maxWidth: 220, minWidth: 220 }}>
          <Autocomplete
            size="small"
            options={row.assetOptions || []}
            getOptionLabel={(option) => {
              if (typeof option === "string") return option;
              if (option && option.assetName) return option.assetName;
              return "";
            }}
            value={
              (row.assetOptions || []).find(opt => opt.assetName === row.assetName) || null
            }
            onChange={(e, newValue) => {
              if (newValue) {
                handleRowChange(rigIndex, rowIndex, "assetName", newValue.assetName);
                handleRowChange(rigIndex, rowIndex, "owner", newValue.ownerName || "");
                handleRowChange(rigIndex, rowIndex, "groupCode", newValue.groupCode || "");
                handleRowChange(rigIndex, rowIndex, "harmony", newValue.harmonyCode || "");
                handleRowChange(rigIndex, rowIndex, "description", newValue.harmonyName || "");
              } else {
                handleRowChange(rigIndex, rowIndex, "assetName", "");
                handleRowChange(rigIndex, rowIndex, "owner", "");
                handleRowChange(rigIndex, rowIndex, "groupCode", "");
                handleRowChange(rigIndex, rowIndex, "harmony", "");
                handleRowChange(rigIndex, rowIndex, "description", "");
              }
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Asset" size="small" />
            )}
          />
          </TableCell>
          <TableCell sx={{ width: 120, maxWidth: 120, minWidth: 120 }}>{row.owner || ""}</TableCell>
          <TableCell sx={{ width: 120, maxWidth: 120, minWidth: 120 }}>{row.groupCode || ""}</TableCell>
          <TableCell sx={{ width: 120, maxWidth: 120, minWidth: 120 }}>{row.harmony || ""}</TableCell>
          <TableCell sx={{ width: 120, maxWidth: 120, minWidth: 120 }}>{row.description || ""}</TableCell>



          <TableCell>
            <IconButton
              color="error"
              size="small"
              onClick={() => handleDeleteRow(rigIndex, rowIndex)}
              disabled={rig.rows.length === 1}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </TableCell>

          <TableCell sx={{ width: 100, maxWidth: 100, minWidth: 100 }}>
            <Button
            variant="outlined"
            size="small"
            onClick={() =>
              rowIndex === 0
                ? setOpenTimesheet({ rigIndex, rowIndex })
                : copyTimesheet(rigIndex, 0, rowIndex) // copy from first row
            }
          >
            {rowIndex === 0 ? "Timesheet" : "Copy"}
          </Button>

          </TableCell>

          {/* Extra columns for dates: show for all rows if timesheet is open for the rig */}
          {openTimesheet?.rigIndex === rigIndex &&
            fromdate &&
            todate &&
            generateDateRange(fromdate, todate).map((date, dateIndex) => (
              <TableCell key={dateIndex}>
                <TextField
                  size="small"
                  type="text"
                  placeholder="Hrs"
                  inputProps={{
                    maxLength: 5,
                    style: { textAlign: "center", padding: "4px" },
                  }}
                  sx={{ width: 50 }}
                  value={row.timesheet?.[date] || ""}
                  onChange={(e) => {
                    handleRowChange(rigIndex, rowIndex, "timesheet", {
                      [date]: e.target.value,
                    });
                  }}
                />




              </TableCell>
            ))}
        </TableRow>
            ))}
          </TableBody>

        </Table>
        </Box>
        
       
      </Card>
    ))}

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 4, // 👈 added margin-top
            mb: 2,
            px: 3,
          }}
        >
          {/* Cancel button always visible */}
          <Button
            variant="outlined"
            size="small"
            color="secondary"
            onClick={handleCancel}
            sx={{ paddingX: 3, paddingY: 0.8, fontSize: 14 }}
          >
            Cancel
          </Button>

          {/* Submit button only visible if rigs exist */}
          {rigs.length > 0 && (
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={handleSubmitAllRigs}
              sx={{ paddingX: 3, paddingY: 0.8, fontSize: 14 }}
            >
              Submit
            </Button>
          )}
        </Box>



 


  </div>
);
}

export default AddRigDialog;

